/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect, useRef } from 'react';
import { get } from 'lodash';
import {
  DIALOG_RESULT_CANCEL,
  DIALOG_RESULT_OK,
} from '@src/constants';
import userService from '@src/services/user-service';

const withGlobalLoginDialog = (WrapComponent, setDialog) => (props) => {
  const promiseRef = useRef({});
  const [open, setOpen] = useState(false);
  const originUser = userService.getCurrentUser();

  function closeHandle() {
    if (promiseRef.current.promise) {
      promiseRef.current.resolve(DIALOG_RESULT_CANCEL);
    }
    setOpen(false);
  }

  function okHandle() {
    if (promiseRef.current.promise) {
      promiseRef.current.resolve(DIALOG_RESULT_OK);
    }
    setOpen(false);
  }

  useEffect(() => {
    setDialog({
      show: () => {
        setOpen(true);

        promiseRef.current.promise = new Promise((resolveX, rejectX) => {
          promiseRef.current.resolve = resolveX;
          promiseRef.current.reject = rejectX;
        });

        return promiseRef.current.promise;
      },
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentUser = userService.getCurrentUser();
      if (get(originUser, 'access_token') !== get(currentUser, 'access_token')) {
        okHandle();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [open, originUser]);

  return (
    <WrapComponent
      open={open}
      onClose={closeHandle}
    />
  );
};

export default withGlobalLoginDialog;
